import React from "react";
import { alpha } from "@mui/material/styles";
import { InputBase } from "@mui/material";
import Theme from "../../themes/theme";
import { withStyles } from "@mui/styles";

function StyledInputBaseElement(props): JSX.Element {
  return <InputBase autoComplete="rakuten" {...props} />;
}

export const StyledInputBase = withStyles((theme: Theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.UI.white,
    border: `1px solid ${theme.palette.UI.blue_80}`,
    width: "100%",
    padding: "10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:focus": {
      boxShadow: `${alpha(theme.palette.UI.blue_80, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.UI.blue_80,
    },
  },
}))(StyledInputBaseElement);
